import { useQuery } from '@tanstack/react-query';
import { inspectionService } from '../services/inspection.service';
import type { InspectionStatus, InspectionVerification } from '../types/inspection.types';

export const INSPECTION_QUERY_KEY = ['verifications-for-inspection'] as const;

export function useVerificationsForInspection(status: InspectionStatus = 'ACCEPTED'): {
  verifications: InspectionVerification[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
} {
  const query = useQuery({
    queryKey: [...INSPECTION_QUERY_KEY, status],
    queryFn: () => inspectionService.listVerificationsForInspection(status),
  });

  return {
    verifications: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
